import React from 'react';

/**
 * Snakker mark recreated from snakker.io: violet speech bubble with a play glyph + lowercase wordmark.
 * Swap for the official SVG asset when available.
 */
export function SnakkerLogo({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap ${className}`} aria-label="Snakker" data-id="element-682" data-mp="1d60b3ojmgykp">
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" className="shrink-0" data-id="element-683" data-mp="18bcx4jm8vmkd">
        <path d="M12 1.5C6.2 1.5 1.5 6.1 1.5 11.8c0 3 1.3 5.7 3.4 7.6L4.4 23l4.1-2c1.1.4 2.3.6 3.5.6 5.8 0 10.5-4.6 10.5-10.3S17.8 1.5 12 1.5Z" fill="#7C3AED" data-id="element-684" data-mp="1n46ekal2ucro" />
        <path d="M9.6 7.6v8.4l6.8-4.2-6.8-4.2Z" fill="#FFFFFF" data-id="element-685" data-mp="1vxt7zu1tb3xp" />
      </svg>
      <span className="text-[19px] font-bold leading-none tracking-[-0.035em] text-[#0b0b0f]" data-id="element-686" data-mp="1ryaj6n6ve8pl">snakker</span>
    </span>;
}